var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '../button';
import DateRangePicker from '../date-range-picker';
import Icon from '../icon';
import { Styled } from './style';
var MultilineDateInput = /** @class */ (function (_super) {
    __extends(MultilineDateInput, _super);
    function MultilineDateInput(props) {
        var _this = _super.call(this, props) || this;
        _this.addInput = function () {
            var lastValue = _this.state.values[_this.state.values.length - 1];
            if ((lastValue && lastValue.start !== '' && lastValue.end !== '') || _this.state.values.length === 0) {
                _this.setState(function (prevState) { return ({
                    values: __spreadArrays(prevState.values, [{ start: '', end: '' }]),
                    focusIndex: prevState.focusIndex + 1,
                }); });
            }
        };
        _this.removeInput = function (id) { return __awaiter(_this, void 0, void 0, function () {
            var updatedValues;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        updatedValues = this.state.values.filter(function (input, index) { return index !== id; });
                        return [4 /*yield*/, this.setState(function (prevState) { return ({
                                values: updatedValues,
                                focusIndex: prevState.focusIndex - 1,
                            }); })];
                    case 1:
                        _a.sent();
                        this.onChange(updatedValues);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.dateRangePickerOnChange = function (index, data) {
            var values = __spreadArrays(_this.state.values);
            values[index] = data;
            var shouldTriggerOnChange = data.start && data.end;
            _this.setState({
                values: values,
            }, function () {
                if (shouldTriggerOnChange) {
                    _this.onChange(_this.state.values);
                }
            });
        };
        _this.onChange = function (values) {
            if (_this.props.onChange) {
                _this.props.onChange(values.filter(function (item) { return item.start !== '' || item.end !== ''; }));
            }
        };
        var dateValues = __spreadArrays(_this.props.values);
        _this.state = {
            values: dateValues,
            focusIndex: 0,
        };
        return _this;
    }
    MultilineDateInput.getDerivedStateFromProps = function (props, state) {
        if (props.values === state.values) {
            return { values: props.values };
        }
        return null;
    };
    MultilineDateInput.prototype.render = function () {
        var _this = this;
        var disablePastDateSelection = this.props.disablePastDateSelection;
        return (React.createElement(Styled, null,
            this.state.values.length >= 1 &&
                this.state.values.map(function (value, index) { return (React.createElement("div", { key: index, className: "item-row" },
                    React.createElement("div", { className: "date-range-input" },
                        React.createElement(DateRangePicker, { flipWay: _this.props.flipWay, startPlaceholder: 'Start Date', endPlaceholder: "End Date", inverted: _this.props.inverted, locale: _this.props.locale, value: value, disabled: _this.props.disabled, onChange: function (v) { return _this.dateRangePickerOnChange(index, v); }, defaultFocusValue: index === _this.state.focusIndex, disablePastDateSelection: disablePastDateSelection })),
                    React.createElement(Button, { disabled: _this.props.disabled, onClick: function () {
                            _this.removeInput(index);
                        }, transparent: true },
                        React.createElement(Icon, { name: "remove-fill" })))); }),
            !this.props.disabled &&
                React.createElement(Button, { onClick: this.addInput, disabled: this.props.disabled, transparent: true },
                    React.createElement(Icon, { name: "plus-fill" }),
                    this.state.values.length >= 1 ? (React.createElement(FormattedMessage, { id: "ui_component.multiline_date_input.add", defaultMessage: "Add" })) : (React.createElement(FormattedMessage, { id: "ui_component.multiline_date_input.add_specific_date", defaultMessage: "Add specific date" })))));
    };
    return MultilineDateInput;
}(React.Component));
export { MultilineDateInput };
export default MultilineDateInput;
//# sourceMappingURL=index.js.map